import { RouteObject } from "react-router";

import { PortalPage } from "@layouts/PortalPage/PortalPage.layout";

import { routes } from "@pages/routes";

import { Notifications } from "./Notifications/Notifications.page";

export const notificationsRoutes = [
  {
    path: routes.portal.notifications.$path(),
    Component: PortalPage,
    children: [
      {
        index: true,
        Component: Notifications,
        handle: {
          breadcrumb: {
            title: "Notifications",
          },
        },
      },
    ],
  },
] satisfies RouteObject[];
